import LeftDefaultLayout from './LeftDefaultLayout';

export default LeftDefaultLayout;